import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcUserRoleSolidComponent for rendering solid user role icon with optional gradient.
 */
@Component({
  selector: 'ic-user-role-solid',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-user-role-solid.html',
})
export class IcUserRoleSolidComponent {
  /** The starting color of the icon gradient. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 1. */
  @Input() opacity = 1;

  /** The width of the icon. Defaults to 16. */
  @Input() width: number | string = 16;

  /** The height of the icon. Defaults to 17. */
  @Input() height: number | string = 17;

  /** Solid color for the icon. */
  @Input() color = 'currentColor';

  /** Default color when no color or gradient is provided. */
  defaultColor = '#B8C0C6';

  /** Unique ID for the SVG gradient. */
  gradientId = `userRoleSolidGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if gradient is provided. */
  get hasGradient(): boolean {
    return !!(this.startColor && this.endColor);
  }
}
